const blobToDataURL = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
      } else {
        reject(
          new Error(`Expected string but received a ${typeof reader.result}`),
        );
      }
    };
    reader.onerror = () => {
      reject(
        reader.error
          ? new Error(reader.error.message)
          : new Error("FileReader error"),
      );
    };
    reader.readAsDataURL(blob);
  });
};

export const toDataURL = async (url: string): Promise<string> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(
      `Failed to fetch resource: ${response.status} ${response.statusText}`,
    );
  }
  const blob = await response.blob();
  return blobToDataURL(blob);
};

export const toDataURLByFile = (file: File): Promise<string> =>
  blobToDataURL(file);
